import { mount } from "svelte";
import { registerSW } from "virtual:pwa-register";
import App from "./App.svelte";
import "./app.css";

// Service worker register avec auto-update.
// `immediate: true` → check une mise à jour dès le boot (pas à la 1ère navigation).
// Auto-reload silencieux au prochain refresh utilisateur — acceptable pour app perso.
registerSW({ immediate: true });

const target = document.getElementById("app");
if (!target) throw new Error("#app not found in index.html");

const app = mount(App, { target });
export default app;
